import React, { useState } from 'react';
import styled from 'styled-components';
import HistoryIcon from '../../../../assets/icons/history-icon.svg';
import { HistoryModal } from '../../modals';

export const HistoryQuestion = ({
  questionTitle,
  questionType,
  answers,
  answersOld,
  availableAnswers
}) => {
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);

  return (
    <>
      <HistoryButton onClick={() => setIsHistoryModalOpen(true)}>
        <HistoryImg src={HistoryIcon} />
      </HistoryButton>
      <HistoryModal
        active={isHistoryModalOpen}
        onClose={() => setIsHistoryModalOpen(false)}
        questionTitle={questionTitle}
        questionType={questionType}
        answers={answers}
        answersOld={answersOld}
        availableAnswers={availableAnswers}
      />
    </>
  );
};

const HistoryButton = styled.button`
  position: relative;
  border: 0;
  width: 22px;
  height: 22px;
  margin-top: 6px;
  padding: 0;
  background: transparent;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

const HistoryImg = styled.img`
  width: 22px;
  height: 22px;
`;
